import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ObterBancoNoticiasState } from "../../reducers/BancoNoticias/obter-banco-noticias.reducer";

export const selectObterBancoNoticiasState = createFeatureSelector<ObterBancoNoticiasState>('obterBancosNoticias');

export const selectDadosObterBancoNoticias = createSelector(
  selectObterBancoNoticiasState,
  (state: ObterBancoNoticiasState) => state.response
);

export const selectObterBancoNoticias = createSelector(
  selectObterBancoNoticiasState,
  (state: ObterBancoNoticiasState) => state
);

export const selectErrosObterBancoNoticias = createSelector(
  selectObterBancoNoticiasState,
  (state: ObterBancoNoticiasState) => state.error
);
